import React, { useState } from 'react';

export default function Accordion({ items }) {
  const [openKey, setOpenKey] = useState(null);

  return (
    <div className="ps-accordion">
      {items.map(item => {
        const isOpen = openKey === item.key;
        return (
          <div key={item.key} className="ps-accordion-item">
            <button
              type="button"
              aria-expanded={isOpen}
              aria-controls={`panel-${item.key}`}
              onClick={() => setOpenKey(isOpen ? null : item.key)}
            >
              {item.title}
              <span>{isOpen ? '−' : '+'}</span>
            </button>
            {isOpen && (
              <div id={`panel-${item.key}`} role="region" className="ps-accordion-body">
                {item.body}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
